import { createSlice } from "@reduxjs/toolkit";

export const searchSlice = createSlice({
  name: "search",
  initialState: {
    searchData: {
      search: "",
      radius: "",
      time: '1.50',
      category: [],
      required_expertise: []
    },
    data: {
      asrList: [],
      latitude: null,
      longitude: null,
    },
    configs: {
      radius: [],
      categories: [],
      required_expertises: [],
      time: ''
    },
    selectedRow: {},
    loading: false,
    showDrawer: true,
    isModalShow: false,
    isEdit: false,
    isSearchBtnClicked: false,
    errors: {
      address: '',
      noResult: '',
    }
  },
  reducers: {
    setSearchData: (state, action) => {
      state.searchData = action.payload;
    },
    setASRData: (state, action) => {
      state.data = action.payload;
    },
    setConfigs: (state, action) => {
      state.configs = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setShowDrawer: (state, action) => {
      state.showDrawer = action.payload;
    },
    setRowData: (state, action) => {
      state.selectedRow = action.payload;
    },
    setIsModalShow: (state, action) => {
      state.isModalShow = action.payload;
    },
    setIsEdit: (state, action) => {
      state.isEdit = action.payload;
    },
    setIsSearchBtnClicked: (state, action) => {
      state.isSearchBtnClicked = action.payload
    },
    setErrors: (state, action) => {
      state.errors = action.payload
    },
    onClearSearchData: (state) => ({
      ...state,
      searchData: {
        search: "",
        radius: "",
        time: state.configs.time,
        category: [],
        required_expertise: []
      }
    }),
    onClearData: (state) => ({
      ...state, 
      data: {
        asrList: [],
        latitude: null,
        longitude: null,
      }
    }),
  }
});

export const {
  setSearchData,
  setASRData,
  setConfigs,
  setLoading,
  setShowDrawer,
  setIsModalShow,
  setRowData,
  setIsEdit,
  setIsSearchBtnClicked,
  setErrors,
  onClearSearchData,
  onClearData
} = searchSlice.actions;

export default searchSlice.reducer;
